// Feature announcements shown as dismissible banners on the dashboards.
//
// To announce a new feature, add ONE entry to the top of this array:
//   id:       unique, stable string — NEVER reuse or change once shipped
//             (it's the per-user "dismissed" key). Suffix with the date.
//   audience: 'all' | 'admin' | 'therapist'  (who sees it)
//   icon:     emoji shown before the title
//   title:    short bold lead-in
//   text:     the message
//
// Banners are dismissed per-user in the browser (localStorage). They appear on
// the next dashboard load/login, not on a page that's already open.
export const ANNOUNCEMENTS = [
  {
    id: 'movable-dashboard-widgets-2026-07-01',
    audience: 'all',
    icon: '🧩',
    title: 'New: Make Your Dashboard Yours',
    text: "You can now rearrange your dashboard! Drag the ✥ handle on any widget's title bar to move it, hit ✕ to hide one you don't use, and open ⚙ Customize (top right) to bring widgets back or reset the default layout. Your arrangement saves automatically and follows you on any device.",
  },
  {
    id: 'therapist-card-update-link-2026-07-01',
    audience: 'therapist',
    icon: '💳',
    title: 'New: Send a Card-Update Link',
    text: "You can now email a client a secure link to add or update the card on file. Go to My Clients → Client Profiles, select the client, then click the “Send Card-Update Link” button (next to Generate Intake Link) — confirm the prefilled email, add a note if you like, and send.",
  },
  {
    id: 'shout-out-reactions-2026-06-25',
    audience: 'all',
    icon: '🎉',
    title: 'New portal feature',
    text: "React to shout-outs! Add an emoji to a teammate's shout-out on the Team page.",
  },
  {
    id: 'sent-links-2026-06-24',
    audience: 'therapist',
    icon: '🔗',
    title: 'New: Sent Links',
    text: "Track the welcome/intake and ROI links you've sent under My Clients → Sent Links — and you'll get a banner here when a client completes one.",
  },
  {
    id: 'payment-links-2026-06-24',
    audience: 'admin',
    icon: '💳',
    title: 'New: Payment Links',
    text: 'See the status of every card-collection link, and email card-update links, under Collections → Payment Links.',
  },
];
